/**
 * Represents the processing status of an NDC Destination import file.
 */
export enum NdcDestinationFileStatusModel {
	/**
	 * The file failed validation and contains errors.
	 */
	ValidationFailed = 13,
	/**
	 * The file is currently being processed.
	 */
	ProcessingProgress = 64,
	/**
	 * The file processing failed due to an internal error.
	 */
	ProcessingFailed = 65,
	/**
	 * The file was successfully processed.
	 */
	Processed = 66,
	/**
	 * Overlapping records were detected in the file.
	 */
	OverlapsFound = 91
}
